import { request } from '../lib/http'
import { requestUpload } from '../lib/httpUpload'

export function fetchAll (params) {
  return request({
    url: `extracts?${params}`,
    method: 'get'
  })
}

export function fetchFinishedOs () {
  return request({
    url: 'finished-os',
    method: 'get'
  })
}

export function fetchFinishedOsFiltered (params) {
  return request({
    url: 'finished-os',
    method: 'get',
    params
  })
}

export function fetchPrintExtract (id) {
  return request({
    url: `print-extract`,
    method: 'get',
    params: id
  })
}

export function addExtract (extract) {
  return request({
    method: 'post',
    url: 'extract',
    data: extract
  })
}

export function show (id) {
  return request({
    url: `extract/${id}`,
    method: 'get'
  })
}

export function edit (data) {
  return request({
    url: `extract`,
    method: 'patch',
    data
  })
}

export function removeOs (id) {
  return request({
    url: `remove-os/${id}`,
    method: 'patch',
  })
}

export function uploadPaymentVoucher(data) {
  return requestUpload({
    url: 'upload/paymentvoucher',
    method: 'post',
    data: data.formData,
    params: data.data
  })
}

export function sendEmail(id) {
  return request({
    url: 'only-send-email',
    method: 'get',
    params: id
  })
}